import React, { useEffect, useRef } from 'react'
import Button from '../../components/Button/Button'
import { GoFlame } from 'react-icons/go'
import PriceCard from '../../components/PriceCard/PriceCard'
import { FaRegCircle } from 'react-icons/fa'
import { useDispatch, useSelector } from 'react-redux'
import { getAllProduct } from '../../store/features/product/productSlice'
import { useNavigate } from 'react-router-dom'
import { addToCart } from '../../store/features/cart/cartSlice'
import WhatsAppButton from '../../components/Button/WhatsAppButton'

const POSBillingSofrware = () => {
  document.title = "MACRUM | POS Billing Software for Retail Shop"
  document.querySelector('meta[property="og:title"]').setAttribute('content', 'MACRUM | POS Billing Software for Retail Shop')
  document.querySelector('meta[rel="canonical"]').setAttribute('href', 'https://macrum.in/pos-billing-software')
  useEffect(() => {
    const script = document.createElement('script');
    script.innerHTML = "gtag('event', 'conversion', {'send_to': 'AW-16885706006/smXrCOCm0qkaEJba3fM-'});";
    document.head.appendChild(script);
  }, [])
  const pricing = useRef()
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const {products} = useSelector((store) => store.product)

  const scrollHandle = (elementRef) => {
    window.scrollTo({
      top: elementRef.current.offsetTop,
      behavior: 'smooth'
    })
  }
  
  useEffect(() => {
    dispatch(getAllProduct())
  },[])

  const handleAddToCart = (product) => {
    dispatch(addToCart(product))
    navigate("/checkout")
  }

  return (
    <>
        <div className='w-full flex flex-col md:flex-row items-center justify-between p-4 pt-32 md:pt-20 gap-20 relative'>
            <div className='absolute left-1/2 w-1/2 inset-0 gradient-02' />
            <div className='flex flex-col gap-2 z-10 md:max-w-[21rem] lg:max-w-[31rem]'>
                <p className='text-slogan'>Luxury Billing Software Brand for Premium Customers</p>
                <h1 className='h1 text-white'>MACRUM POS</h1>
                <p className='p mb-4'>Experience a user-friendly, fast and powerful premier billing software, excelling in billing, inventory management and marketing technology, AI technology and e-commerce API connectivity setting the standard for retail success.</p>
                <div className='flex flex-col md:flex-row gap-x-4 gap-y-4'>
                  <Button text='Buy Now' link='' icon={GoFlame} onClick={() => scrollHandle(pricing)} />
                  
                  <WhatsAppButton text='Demo' />
                </div>
            </div>
            <div className='w-80 md:w-96 z-10'>
                <img src="assets/MACRUM_POS_SOFTWARE.png" alt="" />
            </div>
        </div>

        <div className='p-4'>
          <h2 className='h2 text-white pb-4 text-center w-80 md:w-96 mx-auto'>Building for the success of</h2>
          
          <div className='w-fit grid grid-cols-2 md:grid-cols-5 items-center gap-y-4 gap-x-4 mx-auto'>
            <div className='flex-center border rounded-md w-40 h-28 bg-blue-950 border-blue-800'>
              <div>
                <p className='text-white text-xl font-semibold'>Retail Shop</p>
              </div>
            </div>
            <div className='flex-center border rounded-md w-40 h-28 bg-blue-950 border-blue-800'>
              <div>
                <p className='text-white text-xl font-semibold'>Grocery Store</p>
              </div>
            </div>
            <div className='flex-center border rounded-md w-40 h-28 bg-blue-950 border-blue-800'>
              <div>
                <p className='text-white text-xl font-semibold'>Clothing Shop</p>
              </div>
            </div>
            <div className='flex-center border rounded-md w-40 h-28 bg-blue-950 border-blue-800'>
              <div>
                <p className='text-white text-xl font-semibold'>Super Market</p>
              </div>
            </div>
            <div className='flex-center border rounded-md w-40 h-28 bg-blue-950 border-blue-800'>
              <div>
                <p className='text-white text-xl font-semibold'>Mobile Shop</p>
              </div>
            </div>
            <div className='flex-center border rounded-md w-40 h-28 bg-blue-950 border-blue-800'>
              <div>
                <p className='text-white text-xl font-semibold'>Book Store</p>
              </div>
            </div>
            <div className='flex-center border rounded-md w-40 h-28 bg-blue-950 border-blue-800'>
              <div>
                <p className='text-white text-xl font-semibold'>Footwear Shop</p>
              </div>
            </div>
            <div className='flex-center border rounded-md w-40 h-28 bg-blue-950 border-blue-800'>
              <div>
                <p className='text-white text-xl font-semibold'>Jewellery Shop</p>
              </div>
            </div>
            <div className='flex-center border rounded-md w-40 h-28 bg-blue-950 border-blue-800'>
              <div>
                <p className='text-white text-xl font-semibold'>Bakery Store</p>
              </div>
            </div>
            <div className='flex-center border rounded-md w-40 h-28 bg-blue-950 border-blue-800'>
              <div>
                <p className='text-white text-xl font-semibold'>Home Appliance</p>
              </div>
            </div>
          </div>
        </div>

        <div className='w-full flex flex-col-reverse md:flex-row items-center justify-between p-4 relative'>
            <div className='flex flex-col gap-2 z-10 md:max-w-[21rem] lg:max-w-[31rem]'>
                <h5 className='text-xl text-white font-semibold'>Add Product</h5>
                <p className='p mb-4'></p>
            </div>
            <div className='w-80 md:w-96 z-10'>
                <img src="assets/images/Add Product.png" alt="" />
            </div>
        </div>

        <div className='w-full flex flex-col-reverse md:flex-row-reverse items-center justify-between p-4 relative'>
            <div className='flex flex-col gap-2 z-10 md:max-w-[21rem] lg:max-w-[31rem]'>
                <h5 className='text-xl text-white font-semibold'>Dual Sale Panel</h5>
                <p className='p mb-4'>Our billing software offers a traditional barcode scanning selling option, catering to diverse retail needs. Both sale panels in the MACRUM POS software are designed to be advanced and user-friendly. Whether you prefer the convenience of the product image-based sale panel or the efficiency of the barcode scanning option, you can seamlessly switch between them while ensuring consistency in your inventory and sales reports. This flexibility ensures that you can adapt the sales panels according to your specific business requirements, providing a seamless experience for both you and your customers.</p>
            </div>
            <div className='w-80 md:w-96 z-10'>
                <img src="assets/images/Sale Panel.png" alt="" />
            </div>
        </div>

        <div className='w-full flex flex-col-reverse md:flex-row items-center justify-between p-4 relative'>
            <div className='flex flex-col gap-2 z-10 md:max-w-[21rem] lg:max-w-[31rem]'>
                <h5 className='text-xl text-white font-semibold'>Purchase Entry</h5>
                <p className='p mb-4'></p>
            </div>
            <div className='w-80 md:w-96 z-10'>
                <img src="assets/images/Purchase Entry.png" alt="" />
            </div>
        </div>

        <div className='w-full flex flex-col-reverse md:flex-row-reverse items-center justify-between p-4 relative'>
            <div className='flex flex-col gap-2 z-10 md:max-w-[21rem] lg:max-w-[31rem]'>
                <h5 className='text-xl text-white font-semibold'>Send Bill to Customer Mail or WhatsApp</h5>
                <p className='p mb-4'>You can create an invoice and instantly send a digital copy to your customers through WhatsApp or email. This revolutionary technology is integrated into the MACRUM POS software. You have the option to link your private email to this billing software for your business or connect your personal WhatsApp to it. With both options, you can send unlimited messages or emails to your unlimited customers.</p>
            </div>
            <div className='w-80 md:w-96 z-10'>
                <img src="assets/images/Print Preview.png" alt="" />
            </div>
        </div>

        <div ref={pricing} className='px-4 lg:px-16 py-4 mt-4 relative' id='pricing'>
      
          <h2 className='h2 text-white pb-4 text-center w-80 md:w-96 mx-auto relative z-10'>Pricing</h2>

          <div className='w-full col-span-3'>
            <div className='flex flex-wrap justify-center gap-y-8 sm:gap-x-4'>
                    <PriceCard
                      title={"Enterprise Edition"}
                      validity={"1 Year"}
                      price={"10000"}
                      taxType={"Inclusive all texes"}
                      numberOfUser={"Multi-user"}
                    />
            </div>
          </div>
        </div>
    </>
  )
}

export default POSBillingSofrware
